import React from 'react';
import { Information, InformationFilled } from '@carbon/react/icons';
import styles from './information-icon-trigger.module.scss';

interface InformationIconTriggerProps {
  active?: boolean;
  onClick?: () => void;
}

const InformationIconTrigger: React.FC<InformationIconTriggerProps> = ({
  active = false,
  onClick,
}) => {
  const iconContent = (
    <div className={styles.infoContainer}>
      <div className={styles.fixedSizeIconWrapper}>
        {active ? <InformationFilled size={20} /> : <Information size={20} />}
      </div>
    </div>
  );

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  if (active) {
    return (
      <div className={styles.iconButtonWrapper} onClick={handleClick}>
        {iconContent}
      </div>
    );
  }

  return (
    <div className={styles.iconButtonWrapper} onClick={handleClick}>
      {iconContent}
    </div>
  );
};

export default InformationIconTrigger;
